module.exports = __webpack_public_path__ + "img/weibo.f96b43be.png";